<template>
  <div>
    <div class="flex items-center justify-between mb-4">
      <h2>{{$t('All Announcements')}}</h2>
      <span class="font-medium text-primary cursor-pointer">
        <vs-button
          @click="newUpdate"
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          size="large"
        >
        </vs-button>
      </span>
    </div>
    
    <shipblu-table
      :sst="true"
      multiple
      v-model="selected"
      pagination
      :max-items="maximumItems"
      @selectedCriteria="selectedCriteria = $event"
      :data="updates"
      :tableLoader="tableLoader"
      :hideHeader="true"
    >
      <template slot="thead">
        <shipblu-th>{{$t('Announcement Date')}}</shipblu-th>
        <shipblu-th>{{$t('Announcement Text Arabic')}}</shipblu-th>
        <shipblu-th>{{$t('Announcement Text English')}}</shipblu-th>
        <shipblu-th>{{$t('Announcement Link Text English')}}</shipblu-th>
        <shipblu-th>{{$t('Announcement Link Text Arabic')}}</shipblu-th>
        <shipblu-th>{{$t('Announcement Link URL')}}</shipblu-th>
        <shipblu-th class="flex justify-center">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5"/>
        </shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td class="sm:hidden block col-span-2 p-0 order-3">
            <!-- line -->
            <p style="background-color: #DCDCDC;height: 1px;"></p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].date" class="order-2 sm:pointer-events-none">
            <p class="sm:text-base text-lg">
              {{ (data[indextr].date) ? new Date(data[indextr].date).toLocaleDateString('fr-CA') : '' }}
            </p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].en_text" class="order-4">
            <p class="sm:text-base text-sm">
              {{ data[indextr].en_text }}
            </p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].ar_text" class="order-5">
            <p class="sm:text-base text-sm">
              {{ data[indextr].ar_text }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-6" :data="data[indextr].en_link_text">
            <p class="sm:text-base text-sm">
              {{ data[indextr].en_link_text }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-7" :data="data[indextr].ar_link_text">
            <p class="sm:text-base text-sm">
              {{ data[indextr].ar_link_text }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].link_url">
            <p class="sm:text-base text-sm">
              <a :href="data[indextr].link_url" target="_blank">{{ data[indextr].link_url}}</a>
            </p>
          </shipblu-td>

          <shipblu-td class="order-9">
            <shipblu-button @click="deleteUpdate(data[indextr].id)" color="danger" size="small" :textButton="$t('Delete')"></shipblu-button>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
    <updates-modal v-if="updateModal" :updateModal="updateModal" @updateModal="updateModal = $event" @loadUpdates="loadUpdates" />
  </div>
</template>

<script>
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'
import UpdatesModal from './UpdatesModal.vue'
import i18nData from '../../i18n/i18nData'
import { sendRequest } from '../../http/axios/requestHelper'

export default {
  data () {
    return {
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      selected: [],
      updates: [],
      updateModal: false,
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      tableLoader: false
    }
  },
  methods: {
    newUpdate () {
      this.updateModal = true
    },
    deleteUpdate (data) {
      this.deleteData = data
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Are you sure to delete?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      sendRequest(false, false, this, `api/v1/announcements/${this.deleteData}/`, 'delete', null, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Announcement'] + i18nData[this.$i18n.locale][' has been deleted successfully!'],
            position: 'top-center'
          })
          this.loadUpdates()
        }
      )
    },
    loadUpdates () {
      this.tableLoader = true
      sendRequest(false, false, this, `api/v1/announcements/?offset=${this.offset}&limit=${this.maximumItems}`, 'get', null, true, 
        (response) => {
          this.updates = response.data.results
          this.totalRows = response.data.count
          this.tableLoader = false
        })
    }
  },
  created () {
    this.loadUpdates()
    this.offset = (this.currentPage - 1) * this.maximumItems
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination,
    UpdatesModal
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table {
  display: none;
}
</style>
